import React from 'react';
import PackageOptionsList from './PackageOptionsList';
import OptionCheckbox from '../common/options/OptionCheckbox';
import OptionMore from '../common/options/OptionMore';
import PackagePricing from '../components/packages/PackagePricing';

const PackageOption = ({
  option,
  cashAllowanceSelected,
  analyticsKey,
  onChange
}) => {
  const { description, id } = option;
  const packageOptions = option.packageOptions || [];

  return (
    <div className="option package-list-item">
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={option.id}
            checked={option.selected}
            analyticsKey={analyticsKey}
            analyticsKey2={description}
            onChange={() => onChange(option)}
          />
        </div>
        <div className="option__column package-list-item__content">
          <div
            onClick={() => onChange(option)}
            className="option__title option__selectable stat-text-link"
            dangerouslySetInnerHTML={{ __html: description }}
            data-dtm={analyticsKey}
            data-dtm2={description}
          />
          <PackagePricing
            option={option}
            cashAllowanceSelected={cashAllowanceSelected}
            className="package-list-item__pricing"
          />
          <PackageOptionsList
            id={id}
            options={packageOptions}
            analyticsKey={analyticsKey}
            analyticsKey2={description}
          />
          <OptionMore
            to={`/packages/package/${id}`}
            analyticsKey={analyticsKey}
            analyticsKey2={description}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageOption;
